import i18n from "../i18n";
import * as Yup from "yup";

export const createIssuanceRenewalIdForStaffFromContractedCompaniesSchema = (isAttachments: {
    havePersonalPhoto: number;
    haveNationalIdCopy: number;
    haveContractorsAuthorizationLetter: number;
}) => {
    return Yup.object({
        contractorEmployeeName: Yup.string().required(
            i18n.language === "en"
                ? "Contractor/employee name is required."
                : "اسم الموظف/المقاول مطلوب."
        ),

        nationality: Yup.string().required(
            i18n.language === "en"
                ? "Nationality is required."
                : "الجنسية مطلوبة."
        ),

        nationalId: Yup.string()
            .required(
                i18n.language === "en"
                    ? "National ID is required."
                    : "الهوية الوطنية مطلوبة."
            )
            .matches(
                /^\d{1,10}$/,
                i18n.language === "en"
                    ? "Enter a valid National ID."
                    : "أدخل رقم هوية وطنية صالحاً."
            ),

        nationalIdExpiryDate: Yup.string().required(
            i18n.language === "en"
                ? "National ID expiry date is required."
                : "تاريخ انتهاء الهوية الوطنية مطلوب."
        ),

        dob: Yup.string().required(
            i18n.language === "en"
                ? "Date of birth is required."
                : "تاريخ الميلاد مطلوب."
        ),

        contractorsCompanyName: Yup.string().required(
            i18n.language === "en"
                ? "Contractor's company name is required."
                : "اسم شركة المقاول مطلوب."
        ),

        department: Yup.string().required(
            i18n.language === "en"
                ? "Department is required."
                : "القسم مطلوب."
        ),
        jobPosition: Yup.string().required(
            i18n.language === "en"
                ? "Job position is required."
                : "المسمى الوظيفي مطلوب."
        ),
        workStartDate: Yup.string().required(
            i18n.language === "en"
                ? "Work start date is required."
                : "تاريخ بدء العمل مطلوب."
        ),
        residentialAddress: Yup.string().required(
            i18n.language === "en"
                ? "Residential address is required."
                : "العنوان السكني مطلوب."
        ),
        contactNumber: Yup.string()
            .required(
                i18n.language === "en"
                    ? "Contact number is required."
                    : "رقم الاتصال مطلوب."
            )
            .matches(
                /^\d{1,14}$/,
                i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
            ),
        cardValidityFrom: Yup.string().required(
            i18n.language === "en"
                ? "Card validity from date is required."
                : "تاريخ صلاحية البطاقة من مطلوب."
        ),
        cardValidityUntil: Yup.string().required(
            i18n.language === "en"
                ? "Card validity until date is required."
                : "تاريخ صلاحية البطاقة إلى مطلوب."
        ),


        uploadPersonalPhoto: Yup.mixed().when([], {
            is: () => isAttachments.havePersonalPhoto,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) =>
                schema.required(
                    i18n.language === "en"
                        ? "Photo upload is required."
                        : "تحميل الصورة مطلوب."
                )
        }),

        uploadCopyOfNationalId: Yup.mixed().when([], {
            is: () => isAttachments.haveNationalIdCopy,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) =>
                schema.required(
                    i18n.language === "en"
                        ? "National ID upload is required."
                        : "تحميل الهوية الوطنية مطلوب."
                )
        }),
        uploadContractorsAuthorizationLetter: Yup.mixed().when([], {
            is: () => isAttachments.haveContractorsAuthorizationLetter,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.required(
                i18n.language === "en"
                    ? "Contractor's authorization letter upload is required."
                    : "تحميل خطاب تفويض المقاول مطلوب."
            ),
        }),
    });
}